import loadable from "@loadable/component"
import PropTypes from "prop-types"
import { useEffect, useRef, useState } from "react"
import { connect } from "react-redux"
import { useLocation } from "react-router-dom"

import { retry } from "helpers/application"
import { cn } from "styles/utils"

import DesktopNav from "./desktop-nav"
import MobileHeader from "./mobile-header"

const CountdownBanner = loadable(() =>
  retry(() => import("areas/header/countdown-banner"))
)

const HeaderContent = ({
  announcementBarExp,
  homepageQuickNavExp,
  microbanner,
  pdpStickyNavExp,
  secondMicroBanner,
}) => {
  const [sticky, setSticky] = useState(false)
  const [scrollingUp, setScrollingUp] = useState(false)
  const headerRef = useRef()
  const rafRef = useRef()
  const lastScrollYRef = useRef(0)
  const location = useLocation()

  const isHomepage = location.pathname === "/" || location.pathname === ""
  const shouldHideAnnouncementBar =
    (announcementBarExp === 1 ||
      homepageQuickNavExp === 1 ||
      homepageQuickNavExp === 2) &&
    isHomepage
  const announceBarMicroBanner = shouldHideAnnouncementBar &&
    secondMicroBanner && {
      ...secondMicroBanner,
      desktop_texts: [
        ...secondMicroBanner.desktop_texts,
        ...(microbanner ? microbanner.desktop_texts : []),
      ],
      mobile_texts: [
        ...secondMicroBanner.mobile_texts,
        ...(microbanner ? microbanner.mobile_texts : []),
      ],
    }
  const shouldApplyExperiment =
    location.pathname.includes("/products/") && pdpStickyNavExp > 0

  useEffect(() => {
    const handleScroll = () => {
      rafRef.current = window.requestAnimationFrame(() => {
        if (headerRef.current) {
          const currentScrollY = window.pageYOffset
          const headerHeight = headerRef.current.getBoundingClientRect().height

          setSticky((prev) => {
            const next =
              !location.pathname.includes("cart") &&
              currentScrollY > headerHeight + 50
            return prev === next ? prev : next
          })

          if (shouldApplyExperiment && pdpStickyNavExp === 1) {
            setScrollingUp((prev) => {
              const next = currentScrollY < lastScrollYRef.current
              return prev === next ? prev : next
            })
          }

          lastScrollYRef.current = currentScrollY
        }
      })
    }

    window.addEventListener("scroll", handleScroll)
    return () => {
      window.cancelAnimationFrame(rafRef.current)
      window.removeEventListener("scroll", handleScroll)
    }
  }, [location.pathname, shouldApplyExperiment, pdpStickyNavExp])

  return (
    <header
      className={cn(
        "backface-hidden border-b-grey-10 duration-400 top-0 z-40 flex w-full flex-col bg-white transition-all ease-out",
        shouldApplyExperiment
          ? pdpStickyNavExp === 1 &&
              (!sticky || scrollingUp
                ? "sticky translate-y-0"
                : "-translate-y-full")
          : "sticky",
        sticky ? "shadow-lg" : "shadow-none",
        location.pathname.includes("cart") && "tablet:static"
      )}
      ref={headerRef}
    >
      {/* {shouldSimplifyAboveFoldOnMobile ? (
        <>
          {secondMicroBanner && (
            <CountdownBanner
              isSecondMicroBanner
              microbanner={secondMicroBanner}
              showOnDesktop={false}
            />
          )}
          <CountdownBanner microbanner={microbanner} showOnMobile={false} />
        </>*/}
      {shouldHideAnnouncementBar ? (
        <>
          {announceBarMicroBanner && (
            <CountdownBanner
              expVariant
              isSecondMicroBanner
              microbanner={announceBarMicroBanner}
            />
          )}
        </>
      ) : (
        <CountdownBanner microbanner={microbanner} />
      )}
      <MobileHeader />
      <DesktopNav />
      {!shouldHideAnnouncementBar && secondMicroBanner && (
        <CountdownBanner
          isSecondMicroBanner
          microbanner={secondMicroBanner}
          // showOnMobile={!shouldSimplifyAboveFoldOnMobile}
        />
      )}
    </header>
  )
}

HeaderContent.propTypes = {
  announcementBarExp: PropTypes.number,
  // holdbackExp: PropTypes.number,
  homepageQuickNavExp: PropTypes.number,
  microbanner: PropTypes.object,
  pdpStickyNavExp: PropTypes.number,
  secondMicroBanner: PropTypes.object,
}

const mapStateToProps = (state) => {
  return {
    announcementBarExp: state.experiment.announcementBar.variant_id,
    // holdbackExp: state.experiment.holdback.variant_id,
    homepageQuickNavExp: state.experiment.homepageQuickNav.variant_id,
    microbanner: state.sale.microbanner,
    pdpStickyNavExp: state.experiment.pdpStickyNav.variant_id,
    secondMicroBanner: state.sale.second_microbanner,
  }
}

export default connect(mapStateToProps)(HeaderContent)
